"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.DumbappNamespace = void 0;
exports.getWindow = getWindow;
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
class DumbappNamespace {
  constructor() {
    (0, _defineProperty2.default)(this, "initialized", false);
    (0, _defineProperty2.default)(this, "contexts", {});
    (0, _defineProperty2.default)(this, "currentType", null);
  }
  currentContext() {
    if (!this.currentType) {
      return Object.values(this.contexts)[0];
    }
    return Object.values(this.contexts).find(it => it.type === this.currentType);
  }
  addContext(context) {
    this.contexts[context.type] = context;
  }
  removeContext(type) {
    delete this.contexts[type];
  }
  getContext(type) {
    return this.contexts[type];
  }
  account() {
    return this.currentContext().account;
  }
  chainId() {
    return this.currentContext().chainId;
  }
}
exports.DumbappNamespace = DumbappNamespace;
let windowLike;
function getWindow() {
  if (windowLike) {
    return windowLike;
  }

  // @ts-ignore
  if (window) {
    // @ts-ignore
    let win = window;
    if (!win.dumbappNamespace) {
      win.dumbappNamespace = new DumbappNamespace();
    }
    windowLike = win;
  } else {
    windowLike = {
      dumbappNamespace: new DumbappNamespace()
    };
  }
  return windowLike;
}
//# sourceMappingURL=window.js.map